<template>
  <div>
    <el-container>
      <el-header height="48px" class="header-info">
        <span>
          <span>包件编码：</span>
          <span>{{formData.packCode}}</span>
        </span>
        <span>
          <span>包件名称：</span>
          <span>{{formData.packName}}</span>
        </span>
        <span>
          <span>缺货记录天数：</span>
          <span>{{formData.shortageDays}}/180</span>
        </span>
      </el-header>
      <el-main>
        <el-table :data="tableData" border :height="250" v-loading="tableData === null">
          <el-table-column label="序号" prop="id"></el-table-column>
          <el-table-column label="缺货时间段">
            <template slot-scope="scope">
              <span>{{scope.row.startTime}}</span>
              <span style="color: #c6c6c6">至</span>
              <span>{{scope.row.endTime || '今日'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="缺货连续天数" prop="durationDay"></el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 10px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      tableData: null,
      paginationOpt: {
        pageSizes: [30, 100, 500, 1000],
        pageNum: 1,
        pageSize: 30,
        total: 0
      }
    }
  },
  computed: {
    formData() {
      return this.data
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let formData = JSON.parse(JSON.stringify(this.formData));
      delete formData['shortageDays']
      let data = {
        filterData:{
          ...formData,
        },
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize
      }
      this.$q.orderDate.deliveryOutOfStockRecords({data: data})
      .then(res=>{
        if(res.success && res.data && res.data.records.length) {
          this.tableData = res.data.records
          let paginationOpt = {
            total: res.data.total,
            pageNum: res.data.pageNum
          }
          this.paginationOpt = { ...this.paginationOpt, ...paginationOpt }
        }else{
          this.tableData = []
          let paginationOpt = {
            total: 0
          }
          this.paginationOpt = { ...this.paginationOpt, ...paginationOpt }
        }
      })
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
  }
}
</script>

<style lang="stylus" scoped>
  .header-info
    line-height 48px
    &>span
      color #444444
    &>span+span
      margin-left 20px
</style>
